import { render, staticRenderFns } from "./ShipmentEmail.vue?vue&type=template&id=2d9f2643&scoped=true"
import script from "./ShipmentEmail.vue?vue&type=script&lang=js"
export * from "./ShipmentEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9f2643",
  null
  
)

export default component.exports